export default function stylizeLikeWithoutAdvNews(newsId){
    var bodyWrapper = document.getElementById('newsBodyWrap-' + newsId);
    if (bodyWrapper != null && !bodyWrapper.classList.contains('news-body-wrap')) {
        bodyWrapper.classList.add('news-body-wrap');
    }
}